import React from "react";
import GcStudentMasterLayout from "../../../layouts/gcstudent/GcStudentMasterLayout";
import HeroSection from "../../../subsreens/gcstudent/heroSection/HeroSection";
import WhatWeOffer from "../../../subsreens/gcstudent/whatweoffer/WhatWeOffer";
import WhatPeopleSay from "../../../subsreens/gcstudent/whatpeoplesay/WhatPeopleSay";
import LatestBlogs from "../../../subsreens/gcstudent/latestblogs/LatestBlogs";
import ReadyToLearn from "../../../subsreens/gcstudent/readytolearn/ReadyToLearn";
import GetInTouch from "../../../subsreens/gcstudent/getintouch/GetInTouch";
import FeaturedBooksSection from "../../../components/gcstudent/featuredbooksection/FeaturedBooksSection";
import FeaturedPDFsSection from "../../../components/gcstudent/featuredpdfsection/FeaturedPDFsSection";
import FeaturedNotesSection from "../../../components/gcstudent/featurednotessection/FeaturedNotesSection";
import GetInTouchSection from "../../../components/gcstudent/getintouchsection/GetInTouchSection";


const GcLanding = () => {
    return <>
        <GcStudentMasterLayout>
            <HeroSection/>
            <WhatWeOffer/>
            <FeaturedBooksSection/>
            <FeaturedPDFsSection/>
            <FeaturedNotesSection/>
            <WhatPeopleSay/>
            <LatestBlogs/>
            <ReadyToLearn/>
            <GetInTouchSection/>
        </GcStudentMasterLayout>
    
    </>
}

export default GcLanding;